import React, { useState, useEffect } from "react"; // Importa React e hooks
import axios from "axios";

// URL base da API
//const baseUrl = "https://localhost:44304/api/";     //API de DEV
const baseUrl = "http://10.80.12.5:81/api/";      //API de Produção

// Componente principal para exibir a lista de chamados ADM
const TelaChamado = () => {
    // Estado para armazenar os chamados
    const [chamados, setChamados] = useState([]);

    // Busca os chamados na API ao montar o componente
    useEffect(() => {
        const fetchChamados = async () => {
            try {
                // Faz a requisição GET para buscar os chamados ADM
                const response = await axios.get(`${baseUrl}ChamadoADM`);
                setChamados(response.data); // Atualiza o estado com os chamados recebidos
            } catch (error) {
                console.error("Erro ao buscar chamados:", error); // Loga erro caso a requisição falhe
            }
        };
        fetchChamados(); // Chama a função ao montar o componente
    }, []);

    // Renderização da tabela de chamados
    return (
        <div className="container mt-5">
            <h2 className="mb-4 text-center text-primary">Lista de Chamados</h2>
            <div className="table-responsive">
                <table className="table table-striped table-hover shadow-sm">
                    <thead className="bg-dark text-light">
                        <tr>
                            <th>Nome</th>
                            <th>RF</th>
                            <th>Unidade</th>
                            <th>Prioridade</th>
                            <th>Serviço</th>
                            <th>Descrição</th>
                            <th>Imagem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {chamados.length > 0 ? (
                            chamados.map((chamado) => (
                                <tr key={chamado.chamadoId} className="align-middle">
                                    <td className="fw-bold">{chamado.nome}</td>
                                    <td>{chamado.rf}</td>
                                    <td>{chamado.unidade}</td>
                                    <td>
                                        {/* Badge de prioridade para destaque visual */}
                                        <span className={`badge ${chamado.prioridade === "Alta" ? "bg-danger" : "bg-secondary"}`}>
                                            {chamado.prioridade}
                                        </span>
                                    </td>
                                    <td>{chamado.servico}</td>
                                    <td>{chamado.descricao}</td>
                                    <td>
                                        {/* Exibe imagem se houver, senão mostra texto */}
                                        {chamado.imagem ? (
                                            <img
                                                src={`data:image/jpeg;base64,${chamado.imagem}`}
                                                alt={`Chamado ${chamado.nome}`}
                                                className="img-thumbnail shadow-sm"
                                                style={{ width: "150px", height: "150px", objectFit: "cover", transition: "0.3s" }}
                                                onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                                                onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
                                            />
                                        ) : (
                                            <span className="text-muted">Sem imagem</span>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center text-muted py-3">
                                    Nenhum chamado encontrado.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TelaChamado; // Exporta o componente principal